import React, { useState } from "react"
import { Field, useField } from "formik"

export default function Checkbox({ name, label, className, options, ...props }) {
  const [field, meta] = useField({
    name: name,
    type: "checkbox",
    multiple: true
  })

  return (
    <>
      <div id="checkbox-group" className="subtitle mb-2">{label}</div>
      <div role="group" aria-labelledby="checkbox-group" className="grid grid-cols-3 gap-x-10 gap-y-4">
        {options.map(option => (
          <CustomCheckbox
            option={option}
            name={name}
            meta={meta}
          />
        ))}
      </div>
      {meta.touched && meta.error ? (
        <div className="text-red-600 mt-2">{meta.error}</div>
      ) : null}
    </>
  )
}

function CustomCheckbox({ option, name, ...props }) {
  const [isSelected, setSelected] = useState(false)

  function handleClick() {
    setSelected(!isSelected)
  }

  return(
    <label
      className={"flex flex-col items-center text-sm font-sans font-normal normal-case px-3 py-2 cursor-pointer transition-colors duration-200 " + (isSelected ? "bg-gray-300" : "bg-gray-200/50")}
      // onClick={handleClick}
      key={option.value}
    >
      <Field type="checkbox" name={name} value={option.value} className="hidden" onClick={handleClick} />
      {option.value}
    </label>
  )
}